import type { Time } from "../types/Units"

/**
 * Converts a Unix timestamp to an ISO 8601 date string
 * @param time - Optional Time (Unix timestamp in seconds). If undefined, uses current time
 * @returns ISO 8601 formatted date string (e.g., "2025-10-15T12:34:56.789Z")
 */
export const FromUnixTime = (time?: Time): Date =>
  new Date(time ? time * 1000 : Date.now())
